//
//
//
//
//
//
//
//
//
//
//
//
//

  import {mapState} from 'vuex'

  export default {
    name: 'App',
    data() {
      return {
        sideBarContent: window.SIDE_BAR_CONTENT,
        sideBarLink: window.SIDE_BAR_LINK
      }
    },
    computed: {
      ...mapState({
        loading: state => state.loading
      })
    }
  }



// WEBPACK FOOTER //
// ./src/App.vue